import { Observable } from 'rxjs';

export function observableWrapper<T>(data): Observable<T> {
  return new Observable<T>((subscriber) => {
    subscriber.next(data);
    subscriber.complete();
  });
}
